var _defs, _ellipse, _text, _ellipse2, _text2, _ellipse3, _text3, _ellipse4, _text4, _ellipse5, _text5, _ellipse6, _text6, _path, _path2, _path3, _path4, _rect, _text7, _switch;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGraphdrawio(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "391px",
    height: "231px",
    viewBox: "-0.5 -0.5 391 231",
    className: "ge-export-svg-dark",
    content: "<mxfile host=\"Electron\" modified=\"2024-02-10T11:35:49.085Z\" agent=\"Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) draw.io/22.1.16 Chrome/120.0.6099.109 Electron/28.1.0 Safari/537.36\" etag=\"Sqgw-MywAeFshZViJTav\" version=\"22.1.16\" type=\"device\"><diagram name=\"Page-1\" id=\"beBrEWIuwQJhH1_dIsJB\">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</diagram></mxfile>",
    style: {
      backgroundColor: "rgb(24, 20, 29)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "svg.ge-export-svg-dark &gt; * { filter: invert(100%) hue-rotate(180deg); }&#xa;svg.ge-export-svg-dark image { filter: invert(100%) hue-rotate(180deg) }"))), /*#__PURE__*/React.createElement("g", null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 90,
    cy: 50,
    rx: 20,
    ry: 20,
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 50,
      marginLeft: 71
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "1")))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 90,
    y: 54,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "1")))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 310,
    cy: 190,
    rx: 20,
    ry: 20,
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 190,
      marginLeft: 291
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "6")))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 310,
    y: 194,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "6")))), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 370,
    cy: 100,
    rx: 20,
    ry: 20,
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 100,
      marginLeft: 351
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "5")))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 370,
    y: 104,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "5")))), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 170,
    cy: 140,
    rx: 20,
    ry: 20,
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 140,
      marginLeft: 151
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "3")))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 170,
    y: 144,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "3")))), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20,
    cy: 140,
    rx: 20,
    ry: 20,
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 140,
      marginLeft: 1
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "2")))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 144,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "2")))), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 310,
    cy: 20,
    rx: 20,
    ry: 20,
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 20,
      marginLeft: 291
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "4")))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 310,
    y: 24,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "4")))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 79.9 65.97 L 76.25 68.94 L 73.58 70.84 L 70.62 72.66 L 67.31 74.49 L 63.7 76.31 L 59.93 78.12 L 56.34 79.78 L 52.83 81.38 L 49.22 83.08 L 45.72 84.89 L 42.43 86.79 L 39.49 88.84 L 36.79 91.13 L 34.39 93.6 L 32.31 96.12 L 30.64 98.53 L 29.64 100.7 L 29.04 102.8 L 28.67 104.83 L 28.47 106.67 L 28.31 109.53 L 28.35 111.79 L 28.44 113.69 L 28.54 116.14 L 28.58 118.71 L 28.49 119.26 L 28.23 119.75 L 27.83 120.13 L 27.32 120.36 L 26.77 120.42 L 26.23 120.3 L 25.75 120.02 L 25.4 119.6 L 25.19 119.08 L 25.16 118.52 L 25.31 117.99 L 25.62 117.53 L 26.06 117.2 L 26.59 117.02 L 27.14 117.02 L 27.67 117.2 L 28.11 117.53 L 28.42 117.99 L 28.56 118.52 L 28.54 119.08 L 28.33 119.6 L 27.97 120.02 L 27.5 120.3 L 26.96 120.42 L 26.4 120.36 L 25.9 120.13 L 25.49 119.75 L 25.24 119.26 L 25.15 118.71 L 25.15 118.71 L 25.18 116.14 L 25.3 113.68 L 25.4 111.74 L 25.59 109.27 L 26.04 106.29 L 26.42 104.34 L 26.98 102.12 L 27.84 99.8 L 29.13 97.44 L 30.96 94.99 L 33.15 92.39 L 35.67 89.8 L 38.49 87.43 L 41.56 85.28 L 44.93 83.35 L 48.47 81.51 L 52.11 79.78 L 55.6 78.18 L 59.16 76.51 L 62.89 74.7 L 66.42 72.89 L 69.63 71.09 L 72.47 69.26 L 75.04 67.48 L 78.65 64.45 L 78.85 64.32 L 79.07 64.25 L 79.31 64.22 L 79.54 64.26 L 79.76 64.35 L 79.95 64.49 L 80.1 64.67 L 80.21 64.89 L 80.26 65.12 L 80.25 65.36 L 80.18 65.58 L 80.07 65.79 L 79.9 65.97 L 79.9 65.97",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 108.67 57.99 L 110.15 58.59 L 112.11 59.46 L 114.64 60.88 L 116.16 61.98 L 117.73 63.2 L 119.44 64.66 L 121.15 66.27 L 122.95 68.09 L 124.75 70.11 L 126.64 72.45 L 128.56 74.84 L 130.41 77.21 L 132.15 79.69 L 133.68 82.1 L 135.17 84.57 L 136.56 87.13 L 137.84 89.72 L 138.95 92.12 L 139.82 94.41 L 140.59 96.72 L 141.29 98.94 L 141.99 101.16 L 142.69 103.39 L 143.39 105.51 L 144.13 107.7 L 144.82 109.84 L 145.58 112 L 146.4 114.14 L 147.25 116.24 L 148.03 118.24 L 148.78 120 L 149.53 121.7 L 150.67 124.4 L 150.73 124.73 L 150.68 125.07 L 150.53 125.37 L 150.29 125.62 L 149.98 125.77 L 149.65 125.81 L 149.31 125.74 L 149.01 125.57 L 148.79 125.32 L 148.66 125.01 L 148.63 124.67 L 148.72 124.33 L 148.9 124.05 L 149.17 123.84 L 149.49 123.72 L 149.83 123.72 L 150.16 123.82 L 150.43 124.02 L 150.63 124.3 L 150.72 124.63 L 150.71 124.97 L 150.59 125.28 L 150.38 125.54 L 150.09 125.73 L 149.76 125.81 L 149.42 125.77 L 149.11 125.64 L 148.86 125.41 L 148.69 125.12 L 148.69 125.12 L 147.7 122.47 L 146.99 120.71 L 146.3 118.9 L 145.57 116.91 L 144.72 114.79 L 143.89 112.59 L 143.1 110.37 L 142.46 108.26 L 141.73 106.05 L 141.06 103.89 L 140.39 101.65 L 139.73 99.41 L 139.1 97.2 L 138.39 94.92 L 137.64 92.71 L 136.57 90.36 L 135.3 87.82 L 133.93 85.33 L 132.43 82.91 L 130.9 80.58 L 129.17 78.2 L 127.28 75.9 L 125.3 73.59 L 123.36 71.41 L 121.53 69.57 L 119.69 67.91 L 117.98 66.45 L 116.27 65.12 L 114.73 63.98 L 113.34 63.01 L 111.04 61.62 L 109.28 60.66 L 107.81 60.01 L 107.59 59.88 L 107.4 59.69 L 107.25 59.47 L 107.17 59.22 L 107.15 58.96 L 107.19 58.7 L 107.29 58.45 L 107.45 58.24 L 107.65 58.08 L 107.89 57.96 L 108.15 57.91 L 108.42 57.92 L 108.67 57.99 L 108.67 57.99",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 39.28 136.49 L 41.2 136.5 L 43.81 136.43 L 45.27 136.4 L 46.82 136.44 L 48.38 136.5 L 50.19 136.64 L 52.11 136.82 L 54.1 137.01 L 56.23 137.22 L 58.56 137.45 L 61.09 137.69 L 63.68 137.88 L 66.51 138.05 L 69.39 138.14 L 72.6 138.2 L 76.09 138.23 L 80.15 138.26 L 84.7 138.27 L 89.52 138.28 L 94.49 138.34 L 99.43 138.42 L 104.25 138.5 L 108.79 138.64 L 112.96 138.79 L 116.41 138.96 L 119.48 139.18 L 122.18 139.42 L 124.66 139.59 L 126.81 139.72 L 128.72 139.83 L 130.49 139.95 L 132.17 140.07 L 133.85 140.2 L 136.29 140.32 L 138.61 140.42 L 140.02 140.53 L 142.67 140.69 L 145.44 140.85 L 148.39 141.09 L 148.81 141.18 L 149.16 141.4 L 149.43 141.72 L 149.59 142.12 L 149.61 142.54 L 149.5 142.95 L 149.26 143.29 L 148.92 143.55 L 148.52 143.68 L 148.09 143.68 L 147.69 143.54 L 147.36 143.29 L 147.12 142.94 L 147.01 142.53 L 147.03 142.11 L 147.2 141.72 L 147.47 141.39 L 147.84 141.18 L 148.25 141.09 L 148.67 141.14 L 149.05 141.31 L 149.35 141.61 L 149.55 141.98 L 149.62 142.4 L 149.55 142.81 L 149.35 143.19 L 149.04 143.48 L 148.66 143.65 L 148.24 143.7 L 148.24 143.7 L 145.25 143.43 L 143.81 143.31 L 141.13 143.09 L 138.44 142.79 L 136.09 142.53 L 133.63 142.2 L 131.99 141.98 L 130.3 141.76 L 128.56 141.52 L 126.68 141.29 L 124.54 141.04 L 122.05 140.81 L 119.38 140.56 L 116.35 140.35 L 112.9 140.18 L 108.76 140.03 L 104.23 139.9 L 99.4 139.82 L 94.48 139.76 L 89.52 139.72 L 84.7 139.73 L 80.15 139.74 L 76.09 139.75 L 72.59 139.77 L 69.36 139.79 L 66.46 139.8 L 63.59 139.77 L 60.96 139.71 L 58.41 139.61 L 56.06 139.49 L 53.9 139.36 L 51.91 139.23 L 50.01 139.1 L 48.25 138.98 L 46.74 138.9 L 45.27 138.84 L 43.81 138.82 L 41.2 138.75 L 39.28 138.75 L 39 138.72 L 38.76 138.62 L 38.52 138.47 L 38.34 138.26 L 38.22 138.02 L 38.15 137.76 L 38.15 137.48 L 38.22 137.22 L 38.34 136.98 L 38.52 136.78 L 38.76 136.62 L 39 136.52 L 39.28 136.49 L 39.28 136.49",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 324.38 32.24 L 325.44 34.12 L 326.98 36.35 L 327.83 37.59 L 328.73 38.83 L 329.67 40.17 L 330.66 41.57 L 331.74 43.11 L 332.9 44.85 L 334.18 46.66 L 335.51 48.48 L 336.84 50.18 L 338.28 52.02 L 339.73 53.85 L 341.11 55.69 L 342.35 57.36 L 343.49 58.84 L 344.5 60.22 L 345.49 61.59 L 346.47 62.95 L 347.36 64.3 L 348.24 65.66 L 349.17 66.91 L 350.21 68.29 L 351.26 69.68 L 352.26 71.01 L 353.2 72.27 L 354.1 73.5 L 355.68 75.53 L 356.91 77.27 L 357.87 78.69 L 358.71 80.16 L 359.92 82.28 L 360.07 82.72 L 360.07 83.18 L 359.93 83.63 L 359.65 84 L 359.27 84.27 L 358.82 84.4 L 358.35 84.38 L 357.92 84.21 L 357.56 83.91 L 357.32 83.51 L 357.21 83.06 L 357.26 82.6 L 357.45 82.17 L 357.77 81.83 L 358.17 81.61 L 358.63 81.53 L 359.1 81.6 L 359.51 81.81 L 359.83 82.14 L 360.03 82.57 L 360.09 83.03 L 360 83.48 L 359.76 83.89 L 359.41 84.19 L 358.97 84.37 L 358.51 84.4 L 358.06 84.28 L 357.67 84.02 L 357.38 83.66 L 357.38 83.66 L 355.87 80.8 L 355.12 79.44 L 354.21 77.94 L 352.93 76.07 L 352.12 74.93 L 351.25 73.69 L 350.35 72.43 L 349.37 71.09 L 348.34 69.7 L 347.27 68.28 L 346.29 66.89 L 345.45 65.53 L 344.64 64.21 L 343.71 62.82 L 342.78 61.43 L 341.86 60.05 L 340.76 58.53 L 339.55 56.87 L 338.2 55.09 L 336.71 53.29 L 335.2 51.5 L 333.79 49.77 L 332.39 47.98 L 330.99 46.16 L 329.81 44.51 L 328.68 42.96 L 327.68 41.55 L 326.77 40.22 L 325.86 38.91 L 325.05 37.66 L 324.25 36.42 L 323.54 35.21 L 322.44 33.35 L 322.34 33.1 L 322.3 32.84 L 322.32 32.57 L 322.4 32.31 L 322.55 32.08 L 322.74 31.9 L 322.98 31.76 L 323.24 31.69 L 323.51 31.68 L 323.77 31.73 L 324.01 31.85 L 324.22 32.02 L 324.38 32.24 L 324.38 32.24",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 200,
    width: 60,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 215,
      marginLeft: 115
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "RES:0")))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 115,
    y: 219,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "RES:0"))))), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", {
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }), /*#__PURE__*/React.createElement("a", {
    transform: "translate(0,-5)",
    xlinkHref: "https://www.drawio.com/doc/faq/svg-export-text-problems",
    target: "_blank"
  }, /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    fontSize: "10px",
    x: "50%",
    y: "100%"
  }, "Text is not SVG - cannot display")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphdrawio);
export default __webpack_public_path__ + "static/media/graph.drawio.8d92b0aa4639b74ef459821921818e53.svg";
export { ForwardRef as ReactComponent };